import csvDownload from 'json-to-csv-export'

import React, { useState } from 'react';
import { useAuth } from '../../context/authContext';
import { Modal, ModalDialog, ModalClose, DialogTitle, DialogContent, ModalOverflow, Button, Option, Divider, Card, Select, Switch, Input } from '@mui/joy';
import { Typography } from '@mui/joy';
import { Search } from '@mui/icons-material';

import { ApexOptions } from 'apexcharts';
import ReactApexChart from 'react-apexcharts';

import LoadingSpinnerComponent from '../LoadingSpinnerComponent';
import FeedbackResultComponent from './FeedbackResultComponent';

import '../../styles/typography.scss';
import '../../styles/pills.scss';

const networking = require('../../Networking/API');
const helper = require('../../Helpers/helpers');

function StageComponent({ app, stage, onRemoveStage }: any) {
    const { token } = useAuth();

    const [loading, setLoading] = useState(true);
    const [results, setResults] = useState(null) as any[];
    const [showReviews, setShowReviews] = useState(false);
    const [currentVersion, setCurrentVersion] = useState('All');
    const [showTextOnly, setShowTextOnly] = useState(true);
    const [textFilter, setTextFilter] = useState('');

    var yes: any[] = [];
    var no: any[] = [];
    var cleanResults: any[] = [];
    var completed: any[] = [];
    var notCompleted: any[] = [];
    let list = null;
    var barSourceData: any[] = [];
    var barSpecialSourceData: any[] = [];
    var versions: any[] = [];
    var currentItems: any[] = [];

    if (!results) {
        getData();
    }

    function getData() {
        networking.getQueriesForStage(token, stage.id).then((results: any) => {
            setResults(results);
            setLoading(false);
        }).catch((error: Error) => {
            setLoading(false);
        });
    }

    function removeStage(id: string) {
        onRemoveStage(id)
    }

    function filterByVersion(e: any) {
        e.preventDefault();

        const value = e.target.innerText;

        setCurrentVersion(value)
    }

    function filterByText(e: any) {
        e.preventDefault();
        setShowTextOnly(!showTextOnly)
    }

    function exportToCSV() {
        const name = "feedback_" + new Date().toLocaleDateString();

        const data = {
            data: currentItems,
            filename: name + ".csv"
        }

        csvDownload(data)
    }

    if (results) {
        yes = results.filter((r: any) => r.vote === true)
        no = results.filter((r: any) => r.vote === false)
        completed = results.filter((r: any) => r.completed === true)
        notCompleted = results.filter((r: any) => r.completed === false)

        let answerResults = no.filter((r: any) => r.feedback !== '').filter((r: any) => r.feedback !== null).filter((r: any) => r.answers.length === 0);
        let questionsResults = no.filter((r: any) => r.answers.length > 0);

        cleanResults = answerResults.concat(questionsResults).sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
        currentItems = cleanResults;

        barSourceData = groupQueriesByDate(results);
        barSpecialSourceData = groupQueriesByDayAndClassification(results);

        versions = [...new Set(cleanResults.map((r: any) => r.version))];
        versions.sort(function (a: any, b: any) {
            return a.localeCompare(b, undefined, { numeric: true });
        });
        versions.unshift("All");

        if (currentVersion !== 'All') {
            currentItems = currentItems.filter((r: any) => r.version === currentVersion);
        }

        if (showTextOnly) {
            currentItems = currentItems.filter((r: any) => r.feedback !== '')
        }

        if (textFilter.length !== 0) {
            currentItems = currentItems.filter((r: any) => {
                // Search in feedback content
                const feedbackMatch = r.feedback.toLowerCase().includes(textFilter.toLocaleLowerCase());

                // Search in metadata content
                let metadataMatch = false;
                if (r.metadata && r.metadata.length > 0) {
                    metadataMatch = r.metadata.some((item: any) => {
                        const keyValue = helper.parseKeyValue(item);
                        if (keyValue) {
                            return keyValue.key.toLowerCase().includes(textFilter.toLocaleLowerCase()) ||
                                keyValue.value.toLowerCase().includes(textFilter.toLocaleLowerCase());
                        }
                        return false;
                    });
                }

                return feedbackMatch || metadataMatch;
            });
        }

        list = currentItems.map((feedback: any, index: number) =>
            <div
                key={index}
                className=''>
                <FeedbackResultComponent
                    feedback={feedback} />
            </div>
        )
    }

    const categories = Object.keys(barSourceData).sort();
    const sourceData = categories.map((date: any) => barSourceData[date]);
    const goodData = categories.map((date: any) => barSpecialSourceData[date].good);
    const badData = categories.map((date: any) => barSpecialSourceData[date].bad);

    const answerCounts: Record<string, number> = cleanResults
        .flatMap((review: any) => review.answers)
        .reduce((acc: Record<string, number>, answer: any) => {
            acc[answer] = (acc[answer] || 0) + 1;
            return acc;
        }, {} as Record<string, number>);


    // Calculate rating distribution for rating type stages

    const ratingCounts: Record<number, number> = results
        ? results
            .filter((r: any) => r.rating !== null && r.rating !== undefined && r.rating > 0)
            .reduce((acc: Record<number, number>, result: any) => {
                const rating = Math.round(Number(result.rating));
                acc[rating] = (acc[rating] || 0) + 1;
                return acc;
            }, {} as Record<number, number>)
        : {};


    function groupQueriesByDate(queries: any[]): any {

        return queries.reduce((acc: any, query: any) => {
            const day = query.date.split('T')[0];
            acc[day] = (acc[day] || 0) + 1;
            return acc;
        }, {} as Record<string, number>);
    }

    function groupQueriesByDayAndClassification(queries: any[]) {
        return queries.reduce((acc: any, query: any) => {
            const day = query.date.split('T')[0]; // Extract the date (YYYY-MM-DD)
            if (!acc[day]) {
                acc[day] = { good: 0, bad: 0 }; // Initialize counts
            }
            if (query.vote) {
                acc[day].good += 1; // Increment good count
            } else {
                acc[day].bad += 1; // Increment bad count
            }
            return acc;
        }, {} as Record<string, { good: number; bad: number }>);
    }

    const responseOptions: ApexOptions = {
        chart: {
            type: 'pie',
            toolbar: { show: false },
            animations: { enabled: true, speed: 800 }
        },
        legend: {
            show: true,
            position: 'bottom',
            fontSize: '12px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 500,
            markers: {
                strokeWidth: 0,
            },
            itemMargin: {
                horizontal: 10,
                vertical: 4
            }
        },
        fill: {
            opacity: 0.9,
            type: 'solid'
        },
        colors: ["#22C55E", "#EF4444"],
        labels: ["Positive", "Negative"],
        dataLabels: {
            enabled: true,
            style: {
                fontSize: '12px',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                colors: ['#fff']
            },
            formatter: function (val: number) {
                return Math.round(val) + '%';
            },
            dropShadow: {
                enabled: false
            }
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '0%'
                },
                expandOnClick: false
            }
        },
        tooltip: {
            theme: 'light',
            style: {
                fontSize: '12px',
                fontFamily: 'Inter, sans-serif'
            },
            y: {
                formatter: function (value: number) {
                    return Math.round(value) + '%';
                }
            }
        }
    }

    const lineOptions: ApexOptions = {
        chart: {
            type: 'area',
            toolbar: { show: false },
            zoom: { enabled: false },
            animations: { enabled: true, speed: 800 }
        },
        legend: {
            show: false
        },
        colors: ["#008FFB"],
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                opacityFrom: 0.4,
                opacityTo: 0.1,
                stops: [0, 90, 100]
            }
        },
        stroke: {
            curve: 'smooth',
            width: 3
        },
        xaxis: {
            categories: categories,
            labels: {
                show: true,
                style: {
                    fontSize: '11px',
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 500,
                    colors: ['#64748B']
                }
            },
            axisBorder: { show: false },
            axisTicks: { show: false }
        },
        yaxis: {
            labels: {
                style: {
                    fontSize: '11px',
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 500,
                    colors: ['#64748B']
                }
            },
            axisBorder: { show: false },
            axisTicks: { show: false }
        },
        grid: {
            show: true,
            borderColor: "#E2E8F0",
            strokeDashArray: 2,
            position: 'back',
            xaxis: { lines: { show: false } },
            yaxis: { lines: { show: true } },
            padding: { top: 0, right: 0, bottom: 0, left: 0 }
        },
        dataLabels: {
            enabled: false
        },
        tooltip: {
            theme: 'light',
            style: {
                fontSize: '12px',
                fontFamily: 'Inter, sans-serif'
            },
            x: {
                show: true
            },
            y: {
                formatter: function (value: number) {
                    return value + ' interactions';
                }
            }
        },
        markers: {
            size: 4,
            strokeColors: '#008FFB',
            strokeWidth: 2,
            fillOpacity: 1,
            hover: {
                size: 6,
                sizeOffset: 3
            }
        }
    }

    const lineData = {
        series: [{
            name: "Interactions",
            data: sourceData
        }]
    };

    const barOptions: ApexOptions = {
        chart: {
            type: 'bar',
            stacked: true,
            stackType: '100%',
            toolbar: { show: false },
            animations: { enabled: true, speed: 800 }
        },
        legend: {
            show: true,
            position: 'bottom',
            fontSize: '12px',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 500,
            markers: {
                strokeWidth: 0,
            },
            itemMargin: {
                horizontal: 10,
                vertical: 4
            }
        },
        colors: ["#22C55E", "#EF4444"],
        fill: {
            opacity: 0.9,
            type: 'solid'
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['#ffffff']
        },
        xaxis: {
            categories: categories,
            labels: {
                show: true,
                style: {
                    fontSize: '11px',
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 500,
                    colors: ['#64748B']
                }
            },
            axisBorder: { show: false },
            axisTicks: { show: false }
        },
        yaxis: {
            labels: {
                show: false
            },
            axisBorder: { show: false },
            axisTicks: { show: false }
        },
        plotOptions: {
            bar: {
                columnWidth: '100%',
                borderRadius: 6,
                borderRadiusApplication: 'end',
                borderRadiusWhenStacked: 'last',
                dataLabels: {
                    position: 'center'
                }
            }
        },
        grid: {
            show: true,
            borderColor: "#E2E8F0",
            strokeDashArray: 2,
            position: 'back',
            xaxis: { lines: { show: false } },
            yaxis: { lines: { show: true } },
            padding: { top: 0, right: 0, bottom: 0, left: 0 }
        },
        dataLabels: {
            enabled: true,
            style: {
                fontSize: '11px',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 600,
                colors: ['#fff']
            },
            formatter: function (val: number) {
                return Math.round(val) + '%';
            }
        },
        tooltip: {
            theme: 'light',
            style: {
                fontSize: '12px',
                fontFamily: 'Inter, sans-serif'
            },
            y: {
                formatter: function (value: number) {
                    return value + ' queries (' + Math.round((value / (goodData.reduce((a: number, b: number) => a + b, 0) + badData.reduce((a: number, b: number) => a + b, 0))) * 100) + '%)';
                }
            }
        }
    }

    const barData = {
        series: [
            {
                name: 'Good Queries',
                data: goodData,
            },
            {
                name: 'Bad Queries',
                data: badData,
            },
        ],
    };

    const chartOptions: ApexOptions = {
        chart: {
            type: 'bar',
            toolbar: { show: false },
            animations: { enabled: true, speed: 800 }
        },
        colors: ["#3B82F6"],
        fill: {
            opacity: 0.9,
            type: 'solid'
        },
        dataLabels: {
            enabled: true,
            offsetX: 8,
            style: {
                fontSize: '11px',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 600,
                colors: ['#3B82F6']
            },
            formatter: function (value: number) {
                return value.toString();
            }
        },
        xaxis: {
            categories: Object.keys(answerCounts),
            labels: {
                show: true,
                style: {
                    fontSize: '11px',
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 500,
                    colors: ['#64748B']
                }
            },
            axisBorder: { show: false },
            axisTicks: { show: false }
        },
        yaxis: {
            labels: {
                style: {
                    fontSize: '11px',
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 500,
                    colors: ['#64748B']
                }
            },
            axisBorder: { show: false },
            axisTicks: { show: false }
        },
        plotOptions: {
            bar: {
                horizontal: true,
                barHeight: '60%',
                borderRadius: 4,
                dataLabels: {
                    position: 'top'
                }
            }
        },
        grid: {
            show: true,
            borderColor: "#E2E8F0",
            strokeDashArray: 2,
            position: 'back',
            xaxis: { lines: { show: true } },
            yaxis: { lines: { show: false } },
            padding: { top: 0, right: 30, bottom: 0, left: 0 }
        },
        tooltip: {
            theme: 'light',
            style: {
                fontSize: '12px',
                fontFamily: 'Inter, sans-serif'
            },
            y: {
                formatter: function (value: number) {
                    return value + ' responses';
                }
            }
        }
    };

    const answerData = {
        series: [
            {
                name: 'Count',
                data: Object.values(answerCounts), // Corresponding counts
            }
        ],
    };

    return (
        <>
            {/* Review list Modal */}
            <Modal
                open={showReviews}
                onClose={() => setShowReviews(false)}>
                <ModalOverflow>
                    <ModalDialog
                        color="neutral"
                        layout="center"
                        size="sm"
                        variant="plain"
                        minWidth={800}
                        maxWidth={'90vw'}
                        sx={{
                            width: '90vw',
                            maxHeight: '90vh'
                        }}>
                        <ModalClose />
                        <DialogTitle>
                            {stage.name} - Reviews
                        </DialogTitle>
                        <DialogContent>
                            Showing the reviews for this moment.
                        </DialogContent>
                        <Divider />
                        <>
                            <div className='row mt-2 mb-2'>
                                <div className='col'>
                                    <Input
                                        type="text"
                                        size='sm'
                                        placeholder="Type in here…"
                                        startDecorator={<Search />}
                                        onChange={(event) => setTextFilter(event.target.value)}
                                    />
                                </div>
                                {cleanResults && cleanResults.length !== 0 &&
                                    <>
                                        <div className='col-auto my-auto'>
                                            <Select
                                                color="neutral"
                                                placeholder="Version"
                                                size="sm"
                                                variant="outlined"
                                                onChange={filterByVersion}>
                                                {
                                                    versions.reverse().map((version: string) => {
                                                        return (
                                                            <Option
                                                                key={version}
                                                                value={version}>
                                                                {version}
                                                            </Option>
                                                        );
                                                    })
                                                }
                                            </Select>
                                        </div>
                                    </>
                                }
                                <div className='col-auto my-auto'>
                                    <Typography
                                        component="label"
                                        level='body-xs'
                                        startDecorator={
                                            <Switch
                                                checked={showTextOnly}
                                                onChange={(e) => filterByText(e)}
                                                sx={{ mr: 1 }} />
                                        }>
                                        Show with text only
                                    </Typography>
                                </div>
                                <div className='col-auto my-auto'>
                                    <Button
                                        variant="soft"
                                        size='sm'
                                        color="neutral"
                                        loading={loading}
                                        onClick={() => exportToCSV()}>
                                        Export to csv
                                    </Button>
                                </div>
                            </div>
                            {list}
                        </>
                    </ModalDialog>
                </ModalOverflow>
            </Modal >
            {
                loading ?
                    <LoadingSpinnerComponent />
                    :
                    <div className='pt-3'>
                        <div className='row mb-4'>
                            <div className='col-auto'>
                                {results && results?.length > 0 &&
                                    <Button
                                        size='md'
                                        color='primary'
                                        sx={{
                                            borderRadius: '8px',
                                            fontWeight: 500
                                        }}
                                        onClick={() => setShowReviews(true)}>
                                        Show reviews
                                    </Button>
                                }
                            </div>
                            <div className='col-auto'>
                                <Button
                                    size='md'
                                    variant='outlined'
                                    color='danger'
                                    sx={{
                                        borderRadius: '8px',
                                        fontWeight: 500
                                    }}
                                    onClick={() => removeStage(stage)}>
                                    Delete stage
                                </Button>
                            </div>
                        </div>
                        <Typography
                            color='neutral'
                            fontWeight={600}
                            level='body-xs'
                            sx={{
                                marginBottom: '8px'
                            }}>
                            {"info".toUpperCase()}
                        </Typography>
                        <div className='row mb-3'>
                            <div className='col-3'>
                                <Card
                                    size="sm"
                                    variant="soft"
                                    color="neutral"
                                    sx={{ textAlign: 'center', minHeight: '80px' }}>
                                    <Typography level="body-xs" fontWeight="bold">
                                        Created
                                    </Typography>
                                    <Typography level="body-sm" color="neutral">
                                        {helper.formatFriendlyDate(stage.creation_date, navigator.language)}
                                    </Typography>
                                </Card>
                            </div>
                            <div className='col-3'>
                                <Card
                                    size="sm"
                                    variant="soft"
                                    color="primary"
                                    sx={{ textAlign: 'center', minHeight: '80px' }}>
                                    <Typography level="body-xs" fontWeight="bold">
                                        Will attempt to ask for feedback every:
                                    </Typography>
                                    <Typography level="title-md" color="primary">
                                        {stage.ask_every} days
                                    </Typography>
                                </Card>
                            </div>
                            <div className='col-3'>
                                <Card
                                    size="sm"
                                    variant="soft"
                                    color={stage.once_per_version ? "success" : "neutral"}
                                    sx={{ textAlign: 'center', minHeight: '80px' }}>
                                    <Typography level="body-xs" fontWeight="bold">
                                        Displaying once per version ?
                                    </Typography>
                                    <Typography level="title-sm" color={stage.once_per_version ? "success" : "neutral"}>
                                        {stage.once_per_version ? 'Yes' : 'No'}
                                    </Typography>
                                </Card>
                            </div>
                            <div className='col-3'>
                                <Card
                                    size="sm"
                                    variant="soft"
                                    color="neutral"
                                    sx={{ textAlign: 'center', minHeight: '80px' }}>
                                    <Typography level="body-xs" fontWeight="bold">
                                        Type
                                    </Typography>
                                    <Typography level="title-sm" color="neutral">
                                        {stage.type.toLowerCase() === 'yn' ? 'Yes / No' : 'Rating'}
                                    </Typography>
                                </Card>
                            </div>
                        </div>
                        <Divider
                            sx={{
                                marginBottom: 4
                            }} />
                        <Typography
                            color='neutral'
                            fontWeight={600}
                            level='body-xs'
                            sx={{
                                marginBottom: '8px'
                            }}>
                            {"results".toUpperCase()}
                        </Typography>
                        {(cleanResults && cleanResults.length > 0) &&
                            <>
                                <div className='row'>
                                    <div className='col'>
                                        <Card
                                            variant="outlined"
                                            color='neutral'
                                            sx={{
                                                marginTop: 2,
                                                backgroundColor: 'white',
                                                border: '1px solid #f1f5f9',
                                                borderRadius: '12px',
                                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                                                transition: 'all 0.2s ease-in-out',
                                                '&:hover': {
                                                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08)',
                                                    transform: 'translateY(-1px)'
                                                }
                                            }}>
                                            <Typography
                                                level="body-xs"
                                                fontWeight="bold">
                                                Total appearances
                                            </Typography>
                                            <Typography
                                                level="title-md"
                                                color="neutral">
                                                {results ? results.length : 0}
                                            </Typography>
                                        </Card>
                                    </div>
                                    <div className='col'>
                                        <Card
                                            variant="solid"
                                            color='primary'
                                            sx={{
                                                marginTop: 2,
                                                border: '1px solid #f1f5f9',
                                                borderRadius: '12px',
                                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                                                transition: 'all 0.2s ease-in-out',
                                                '&:hover': {
                                                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08)',
                                                    transform: 'translateY(-1px)'
                                                }
                                            }}>
                                            <Typography
                                                level="body-xs"
                                                fontWeight="bold"
                                                sx={{
                                                    color: "#ffffff"
                                                }}>
                                                Completed
                                            </Typography>
                                            <Typography
                                                level="title-md"
                                                color="neutral"
                                                sx={{
                                                    color: "#ffffff"
                                                }}>
                                                {results ? completed.length : 0}
                                            </Typography>
                                        </Card>
                                    </div>
                                    <div className='col'>
                                        <Card
                                            variant="solid"
                                            color='primary'
                                            sx={{
                                                marginTop: 2,
                                                border: '1px solid #f1f5f9',
                                                borderRadius: '12px',
                                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                                                transition: 'all 0.2s ease-in-out',
                                                '&:hover': {
                                                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08)',
                                                    transform: 'translateY(-1px)'
                                                }
                                            }}>
                                            <Typography
                                                level="body-xs"
                                                fontWeight="bold"
                                                sx={{
                                                    color: "#ffffff"
                                                }}>
                                                Not completed
                                            </Typography>
                                            <Typography
                                                level="title-md"
                                                color="neutral"
                                                sx={{
                                                    color: "#ffffff"
                                                }}>
                                                {results ? notCompleted.length : 0}
                                            </Typography>
                                        </Card>
                                    </div>
                                </div>
                                {/* Charts */}
                                {stage.type.toLowerCase() === 'yn' &&
                                    <Card
                                        variant="outlined"
                                        color='neutral'
                                        sx={{
                                            marginTop: 2,
                                            backgroundColor: 'white',
                                            border: '1px solid #f1f5f9',
                                            borderRadius: '12px',
                                            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                                            transition: 'all 0.2s ease-in-out',
                                            '&:hover': {
                                                boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08)',
                                                transform: 'translateY(-1px)'
                                            }
                                        }}>
                                        <Typography
                                            color='neutral'
                                            fontWeight={600}
                                            level='body-xs'>
                                            {"Results distribution".toUpperCase()}
                                        </Typography>
                                        <Divider />
                                        <div className='row mt-4'>
                                            <div className='col'>
                                                <ReactApexChart
                                                    options={responseOptions}
                                                    series={[yes.length, no.length]}
                                                    type="donut"
                                                    height={200} />
                                            </div>
                                        </div>
                                    </Card>
                                }
                                {stage.type.toLowerCase() === 'rating' &&
                                    <>
                                        <Card
                                            variant="outlined"
                                            color='neutral'
                                            sx={{
                                                marginTop: 2,
                                                backgroundColor: 'white',
                                                border: '1px solid #f1f5f9',
                                                borderRadius: '12px',
                                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                                                transition: 'all 0.2s ease-in-out',
                                                '&:hover': {
                                                    boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08)',
                                                    transform: 'translateY(-1px)'
                                                }
                                            }}>
                                            <Typography
                                                color='neutral'
                                                fontWeight={600}
                                                level='body-xs'>
                                                {"Rating statistics".toUpperCase()}
                                            </Typography>
                                            <Divider />
                                            <div className='row mt-3'>
                                                <div className='col-4'>
                                                    <Card
                                                        size="sm"
                                                        variant="soft"
                                                        color="primary"
                                                        sx={{ textAlign: 'center', minHeight: '70px' }}>
                                                        <Typography level="body-xs" fontWeight="bold">
                                                            Average Rating
                                                        </Typography>
                                                        <Typography level="title-md" color="primary">
                                                            {results && results.filter((r: any) => r.rating).length > 0
                                                                ? (results.filter((r: any) => r.rating).reduce((sum: number, r: any) => sum + Number(r.rating), 0) / results.filter((r: any) => r.rating).length).toFixed(1)
                                                                : '0.0'
                                                            }
                                                        </Typography>
                                                    </Card>
                                                </div>
                                                <div className='col-4'>
                                                    <Card
                                                        size="sm"
                                                        variant="soft"
                                                        color="success"
                                                        sx={{ textAlign: 'center', minHeight: '70px' }}>
                                                        <Typography level="body-xs" fontWeight="bold">
                                                            Highest Rating
                                                        </Typography>
                                                        <Typography level="title-md" color="success">
                                                            {results && results.filter((r: any) => r.rating).length > 0
                                                                ? Math.max(...results.filter((r: any) => r.rating).map((r: any) => Number(r.rating)))
                                                                : 0
                                                            }
                                                        </Typography>
                                                    </Card>
                                                </div>
                                                <div className='col-4'>
                                                    <Card
                                                        size="sm"
                                                        variant="soft"
                                                        color="warning"
                                                        sx={{ textAlign: 'center', minHeight: '70px' }}>
                                                        <Typography level="body-xs" fontWeight="bold">
                                                            Most Common Rating
                                                        </Typography>
                                                        <Typography level="title-md" color="warning">
                                                            {Object.entries(ratingCounts).length > 0
                                                                ? Object.entries(ratingCounts).reduce((a: [string, number], b: [string, number]) => a[1] > b[1] ? a : b)[0]
                                                                : 'N/A'
                                                            }
                                                        </Typography>
                                                    </Card>
                                                </div>
                                            </div>
                                        </Card>
                                    </>
                                }
                                <Card
                                    variant="outlined"
                                    color='neutral'
                                    sx={{
                                        marginTop: 2,
                                        backgroundColor: 'white',
                                        border: '1px solid #f1f5f9',
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                                        transition: 'all 0.2s ease-in-out',
                                        '&:hover': {
                                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08)',
                                            transform: 'translateY(-1px)'
                                        }
                                    }}>
                                    <Typography
                                        color='neutral'
                                        fontWeight={600}
                                        level='body-xs'>
                                        {"Interactions overtime".toUpperCase()}
                                    </Typography>
                                    <Divider />
                                    <ReactApexChart
                                        options={lineOptions}
                                        series={lineData.series}
                                        type="area"
                                        height={200} />
                                </Card>
                                <Card
                                    variant="outlined"
                                    color='neutral'
                                    sx={{
                                        marginTop: 2,
                                        backgroundColor: 'white',
                                        border: '1px solid #f1f5f9',
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                                        transition: 'all 0.2s ease-in-out',
                                        '&:hover': {
                                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08)',
                                            transform: 'translateY(-1px)'
                                        }
                                    }}>
                                    <Typography
                                        color='neutral'
                                        fontWeight={600}
                                        level='body-xs'>
                                        {"Sentiment overtime".toUpperCase()}
                                    </Typography>
                                    <Divider />
                                    <ReactApexChart
                                        options={barOptions}
                                        series={barData.series}
                                        type="bar"
                                        height={200} />
                                </Card>
                                <Card
                                    variant="outlined"
                                    color='neutral'
                                    sx={{
                                        marginTop: 2,
                                        backgroundColor: 'white',
                                        border: '1px solid #f1f5f9',
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05)',
                                        transition: 'all 0.2s ease-in-out',
                                        '&:hover': {
                                            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.08)',
                                            transform: 'translateY(-1px)'
                                        }
                                    }}>
                                    <Typography
                                        color='neutral'
                                        fontWeight={600}
                                        level='body-xs'>
                                        {"Options distribution".toUpperCase()}
                                    </Typography>
                                    <Divider />
                                    <ReactApexChart
                                        options={chartOptions}
                                        series={answerData.series}
                                        type="bar"
                                        height={200} />
                                </Card>
                            </>
                        }
                    </div>
            }
        </>
    );
}

export default StageComponent;